import React from "react";

const Spacer4 = ({ size }) => {
  return <div style={{ height: `${size || 160}px` }}></div>;
};

export default Spacer4;

//! Spacer in görevi Customer Service yazısı gibi section title için boşluk bırakır....
